import { FormState, FormValidationFunction } from '@Shared/Components/Forms/FormElement.types'

export const BetweenValuesValidation: (min: number, max: number) => FormValidationFunction<unknown> = (min, max) => (value: string, t) => {
  if (parseFloat(value) >= min && parseFloat(value) <= max) {
    return { state: FormState.VALID }
  }
  return {
    message: t('checkout:COF_WE_NEED_THIS_FIELD_TOO'),
    state: FormState.ERROR,
  }
}
